import { Nullable } from "../models/Common";

export class Rounded {
  private readonly val: Nullable<number>;
  private readonly roundTo: number;
  private readonly roundedValue: Nullable<number> = null;

  private constructor(value: Nullable<number>, round: number) {
    this.val = value;
    this.roundTo = round;
    if (this.val === null || this.val === undefined) {
      this.roundedValue = null;
    } else {
      this.roundedValue = parseFloat(Number(this.val).toFixed(this.roundTo));
    }
  }

  public static of(val: Nullable<number>, round: number) {
    return new Rounded(val, round);
  }

  get raw() {
    return this.value;
  }

  get value(): Nullable<number> {
    return this.roundedValue;
  }
}
